import jwt_decode from 'jwt-decode';
import USER_ROLE from './userRole';

export const isReplayEligibleToken = token => {
    try {
        const payload = token && jwt_decode(token);
        return Boolean(payload && payload.role && payload.role !== USER_ROLE.ADMIN);
    } catch (_) {
        return false;
    }
};

export const createProductAnalyticsSession = ({ enabled, getToken, schedule, initialize, start, stop }) => {
    let activeIdentity = null;
    let generation = 0;

    return token => {
        const identity = isReplayEligibleToken(token) ? jwt_decode(token)._id : null;
        if (identity && identity === activeIdentity) return;
        activeIdentity = identity;
        const request = ++generation;
        stop();
        if (!enabled || !identity) return;

        const isCurrent = () => {
            const currentToken = getToken();
            return request === generation && isReplayEligibleToken(currentToken) && jwt_decode(currentToken)._id === identity;
        };
        schedule(() => {
            if (!isCurrent()) return;
            initialize(isCurrent);
            start(isCurrent);
        });
    };
};

export const startRecordingForCurrentSession = async (sdk, isCurrent) => {
    if (!isCurrent()) return;
    await sdk.start_session_recording();
    // The SDK also loads its recorder asynchronously after loading Mixpanel.
    if (!isCurrent()) await sdk.stop_session_recording();
};
